/* Smooth-scroll handler for #shopify-section-* and #cfp-block-* anchors.
   - Centers the target vertically in the viewport when it's smaller than
     the viewport (so the user "sees the whole element").
   - For elements taller than the viewport, aligns the top with a 24px
     breathing gap below any sticky header (read from the floating
     header's pill rect if present).
   - Runs on initial page load too, in case the URL already includes
     one of those hashes.
*/
(() => {
  if (window.__customSectionScrollInit) return;
  window.__customSectionScrollInit = true;

  function stickyHeaderBottom() {
    // The floating header is a fixed pill. Try a couple of selectors.
    const sel =
      '.custom-header__bar, .custom-header__pill, .shopify-section-header-sticky';
    const el = document.querySelector(sel);
    if (!el) return 0;
    const r = el.getBoundingClientRect();
    if (r.bottom <= 0) return 0;
    return r.bottom;
  }

  function scrollToSection(target) {
    if (!target) return;
    const rect = target.getBoundingClientRect();
    const sectionH = rect.height;
    const viewportH = window.innerHeight || document.documentElement.clientHeight;
    const stickyBottom = stickyHeaderBottom();
    const visibleH = viewportH - stickyBottom;

    let top;
    if (sectionH <= visibleH) {
      // Center the section inside the visible area below any sticky header.
      const offsetInVisible = Math.max(0, (visibleH - sectionH) / 2);
      top = window.pageYOffset + rect.top - stickyBottom - offsetInVisible;
    } else {
      // Section is taller than the viewport — align top with a 24px gap.
      top = window.pageYOffset + rect.top - stickyBottom - 24;
    }
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function isKnownAnchor(hash) {
    return hash && (
      hash.startsWith('#shopify-section-') ||
      hash.startsWith('#cfp-block-')
    );
  }

  function handleHash(hash) {
    if (!isKnownAnchor(hash)) return false;
    const target = document.getElementById(hash.slice(1));
    if (!target) return false;
    scrollToSection(target);
    return true;
  }

  // Intercept clicks on any anchor pointing at a Shopify section, but
  // ONLY if the target section actually exists on the current page.
  // Otherwise let the browser navigate normally — important for links
  // that point at a section on a different page (or no section at all).
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href]');
    if (!a) return;
    const href = a.getAttribute('href') || '';
    if (href.indexOf('#shopify-section-') === -1 && href.indexOf('#cfp-block-') === -1) return;

    let url;
    try { url = new URL(a.href, window.location.href); } catch (_) { return; }
    if (url.pathname !== window.location.pathname) return;
    if (!isKnownAnchor(url.hash)) return;

    // Only intercept when the target actually exists in this document.
    // If not, fall through and let the link do whatever it would do
    // natively (which is a no-op for missing hashes — but crucially we
    // never preventDefault here, so other listeners on the link still
    // fire and the browser still treats the href).
    const target = document.getElementById(url.hash.slice(1));
    if (!target) return;

    e.preventDefault();
    history.pushState(null, '', url.hash);
    scrollToSection(target);
  });

  // Honor a direct visit with a recognized hash in the URL.
  if (window.location.hash && isKnownAnchor(window.location.hash)) {
    // Wait for layout to settle before scrolling.
    if (document.readyState === 'complete') {
      setTimeout(() => handleHash(window.location.hash), 0);
    } else {
      window.addEventListener('load', () => {
        setTimeout(() => handleHash(window.location.hash), 0);
      });
    }
  }

  // React to back/forward hash changes too.
  window.addEventListener('hashchange', () => handleHash(window.location.hash));
})();
